interface HeroProps {
  onCTAClick: () => void;
}

export default function Hero({ onCTAClick }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Video */}
      <div className="absolute inset-0 z-0">
        <video
          src="https://public.readdy.ai/ai/video_res/019d2724-d366-7e00-847b-afeca21e2523.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover object-top"
          aria-label="Génération de leads qualifiés - Clients heureux"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="w-full max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Transformez les visiteurs de votre site en <strong>rendez-vous qualifiés</strong>
          </h1>
          <h2 className="text-lg sm:text-xl md:text-2xl text-white/95 mb-10 leading-relaxed font-light">
            Transformez votre site vitrine en actif commercial
          </h2>
          
          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            data-iclosed-link="https://app.iclosed.io/e/usinealead/rdv-45-min-votre-business-votre-besoin"
            data-embed-type="popup"
            className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 sm:px-10 py-4 sm:py-5 rounded-lg font-bold text-base sm:text-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-2xl hover:shadow-orange-500/50 hover:scale-105 whitespace-nowrap cursor-pointer inline-block"
            aria-label="Obtenir des rendez-vous qualifiés"
          >
            Obtenir des rendez-vous qualifiés
          </a>

          {/* Preuve rapide */}
          <div className="mt-16 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 sm:p-8 w-full max-w-2xl mx-auto">
            <div className="flex items-center justify-center gap-3 mb-3">
              <div className="flex -space-x-2">
                {[1, 2, 3, 4].map((i) => (
                  <div key={i} className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 border-2 border-white"></div>
                ))}
              </div>
              <div className="flex gap-1" aria-label="Note 5 étoiles">
                {[1, 2, 3, 4, 5].map((i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-base sm:text-lg"></i>
                ))}
              </div>
            </div>
            <p className="text-white text-base sm:text-lg font-medium">
              <strong>"+47% de leads qualifiés"</strong>
            </p>
            <p className="text-white/80 text-sm mt-2">
              Plus de 150 entreprises nous font confiance
            </p>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl" aria-hidden="true"></i>
        </div>
      </div>
    </section>
  );
}
